<ul>
  <button (click)="onclick()">CONTACT</button>
</ul>
<div>
  text:
</div>
<div>
  {{text}}
</div>
<div>
  <canvas style="border: solid 1px green" #canvas></canvas>
</div>
